module.exports = __webpack_public_path__ + "img/seco.2800d3a0.webp";